<template>
  <h1>Test page</h1>


  <FormKit
      id="is-active"
      name="active"
      type="toggle"
      label="Is garment type active?"
      v-model="toggleTest"
      on-value-label="Client"
      off-value-label="LR"
      on-value="client"
      off-value="lr"
  />

  Value: {{ toggleTest }}


</template>


<script setup>

import {onMounted, ref, watch } from 'vue'
import {FormKit} from "@formkit/vue";

const toggleTest = ref("client")

const eventFired = async (e) => {
  console.log(e.target.value)
  console.log(toggleTest.value)
}

watch(toggleTest, (newValue) => {
  console.log(newValue);
});

</script>
